import { css } from "@emotion/react";

export const sectionStyle = css`
  margin-bottom: 16px;
`;

export const fullWidthStyle = css`
  width: 100%;
`;
